"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ExpandableCard = _interopRequireDefault(require("../Cards/ExpandableCard/ExpandableCard"));

var _ArticleCard = _interopRequireDefault(require("../Cards/ArticleCard/ArticleCard"));

var _BasicCard = _interopRequireDefault(require("../Cards/BasicCard/BasicCard"));

var _ProgramCard = _interopRequireDefault(require("../Cards/ProgramCard/ProgramCard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var CardList = function CardListComponent(_ref) {
  var dataClient = _ref.dataClient,
      sliceData = _ref.sliceData;
  var items = sliceData.items,
      cards_alignment = sliceData.primary.cards_alignment;
  var cardTypeMap = {
    Expandable: _ExpandableCard["default"],
    Article: _ArticleCard["default"],
    Basic: _BasicCard["default"],
    Program: _ProgramCard["default"]
  };
  var listClasses = (0, _classnames["default"])({
    'content-page__cards': true,
    'content-page__cards--center': cards_alignment === 'Center',
    'content-page__cards--left': cards_alignment === 'Left',
    'content-page__cards--right': cards_alignment === 'Right',
    'content-page__cards--spread': cards_alignment === 'Spread'
  });
  return items.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__cards-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: listClasses
  }, items.map(function (cardItem, idx) {
    var Card = cardTypeMap[cardItem.card_type];
    var key = "".concat(cardItem.card_type, "_").concat(idx);
    return /*#__PURE__*/_react["default"].createElement(Card, {
      cardItem: cardItem,
      dataClient: dataClient,
      key: key
    });
  }))));
};
/* eslint-disable camelcase */


CardList.propTypes = {
  dataClient: _propTypes["default"].shape({}).isRequired,
  sliceData: _propTypes["default"].shape({
    items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      card_type: _propTypes["default"].string.isRequired
    })).isRequired
  }).isRequired
};
var _default = CardList;
exports["default"] = _default;